import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { busDangKyXeApi } from "../../../api/bus/busDangKyXeApi";
import { busDiemDonTraApi } from "../../../api/bus/busDiemDonTraApi";
import { busHinhThucDangKyApi } from "../../../api/bus/busHinhThucDangKyApi";
import { busHinhThucDonTraApi } from "../../../api/bus/busHinhThucDonTraApi";
import { busLoaiDiemDonApi } from "../../../api/bus/busLoaiDiemDonApi";
import { busTrangThaiDangKyApi } from "../../../api/bus/busTrangThaiDangKyApi";
import { busTuyenDuongApi } from "../../../api/bus/busTuyenDuongApi";
import { BusDangKyXeItemResponse } from "../../../models/response/bus/bus_dangkyxe";
import { BusDiemDonTraItemResponse } from "../../../models/response/bus/bus_diemdontra";
import { IBaseResponeModel } from "../../../models/response/base-response";
import {
	eBusDangKyXeActionTypeIds,
	IBusDangKyXeDeleteStart,
	IBusDangKyXeDiemDonTraLoadStart,
	IBusDangKyXeImportStart,
	IBusDangKyXeLoadDetailStart,
	IBusDangKyXeLoadStart,
	IBusDangKyXeSaveStart,
	IBusDangKyXeTuyenDuongChiTietLoadStart,
	IBusDangKyXeTuyenDuongLoadStart,
	IBusDangKyXeValidateImportStart
} from "../../action-types/bus/IBusDangKyXeActionTypes";
import { busDangKyXeActions } from "../../actions/bus/busDangKyXeActions";

export function* busDangKyXeSaga(): any {
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_START, loadBusDangKyXeWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_DETAIL_START, loadBusDangKyXeDetailWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_START, loadBusHinhThucDonTraWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_START, loadBusHinhThucDangKyWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_START, loadBusLoaiDiemDonWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_START, loadBusTrangThaiDangKyWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_START, loadBusTuyenDuongWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_START, loadBusDiemDonTraWorker)
	yield takeLatest(eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_START, loadBusTuyenDuongChiTietWorker)
	yield takeEvery(eBusDangKyXeActionTypeIds.SAVE_START, saveBusDangKyXeWorker)
	yield takeEvery(eBusDangKyXeActionTypeIds.DELETE_START, deleteBusDangKyXeWorker)
	yield takeEvery(eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_START, validateImportBusDangKyXeWorker)
	yield takeEvery(eBusDangKyXeActionTypeIds.IMPORT_START, importBusDangKyXeWorker)
}

function* loadBusDangKyXeWorker(action: IBusDangKyXeLoadStart): any {
	const { dm_coso_id, nam_hoc } = action.payload;
	const res: IBaseResponeModel = yield call([busDangKyXeApi, busDangKyXeApi.SelectByCoSo], dm_coso_id)
	if (res.is_success) {
		const datas: BusDangKyXeItemResponse[] = res.data || [];
		// adm lọc theo năm học ở phía client sau khi lấy theo cơ sở
		const filtered = datas.length !== 0 ? datas.filter((x: BusDangKyXeItemResponse) => x.nam_hoc == nam_hoc) : datas;
		yield put(busDangKyXeActions.loadBusDangKyXeSuccess(filtered))
	} else {
		yield put(busDangKyXeActions.loadBusDangKyXeError(res.message || "Không tải được danh sách đăng ký bus"))
	}
}

function* loadBusDangKyXeDetailWorker(action: IBusDangKyXeLoadDetailStart): any {
	const res: IBaseResponeModel = yield call([busDangKyXeApi, busDangKyXeApi.Detail], action.payload)
	if (res.is_success && res.data) {
		yield put(busDangKyXeActions.loadBusDangKyXeDetailSuccess(res.data))
	} else {
		yield put(busDangKyXeActions.loadBusDangKyXeDetailError(res.message || "Không tải được thông tin đăng ký bus"))
	}
}

function* loadBusHinhThucDonTraWorker(): any {
	const res: IBaseResponeModel = yield call([busHinhThucDonTraApi, busHinhThucDonTraApi.SelectAll])
	if (res.is_success) {
		yield put(busDangKyXeActions.loadBusHinhThucDonTraSuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.loadBusHinhThucDonTraError(res.message || "Không tải được danh sách hình thức đón trả"))
	}
}

function* loadBusHinhThucDangKyWorker(): any {
	const res: IBaseResponeModel = yield call([busHinhThucDangKyApi, busHinhThucDangKyApi.SelectAll])
	if (res.is_success) {
		yield put(busDangKyXeActions.loadBusHinhThucDangKySuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.loadBusHinhThucDangKyError(res.message || "Không tải được danh sách hình thức đăng ký"))
	}
}

function* loadBusLoaiDiemDonWorker(): any {
	const res: IBaseResponeModel = yield call([busLoaiDiemDonApi, busLoaiDiemDonApi.SelectAll])
	if (res.is_success) {
		yield put(busDangKyXeActions.loadBusLoaiDiemDonSuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.loadBusLoaiDiemDonError(res.message || "Không tải được danh sách loại điểm đón"))
	}
}

function* loadBusTrangThaiDangKyWorker(): any {
	const res: IBaseResponeModel = yield call([busTrangThaiDangKyApi, busTrangThaiDangKyApi.SelectAll])
	if (res.is_success) {
		yield put(busDangKyXeActions.loadBusTrangThaiDangKySuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.loadBusTrangThaiDangKyError(res.message || "Không tải được danh sách trạng thái đăng ký"))
	}
}

function* loadBusTuyenDuongWorker(action: IBusDangKyXeTuyenDuongLoadStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectAsync], action.payload)
	if (res.is_success) {
		yield put(busDangKyXeActions.loadBusTuyenDuongSuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.loadBusTuyenDuongError(res.message || "Không tải được danh sách tuyến đường"))
	}
}

function* loadBusDiemDonTraWorker(action: IBusDangKyXeDiemDonTraLoadStart): any {
	const { dm_coso_id, bus_tuyenduong_id, bus_loaidiemdon_id } = action.payload;
	let res: IBaseResponeModel;
	if (bus_tuyenduong_id > 0) {
		res = yield call([busDiemDonTraApi, busDiemDonTraApi.Select], {
			bus_tuyenduong_id: bus_tuyenduong_id,
			bus_loaidiemdon_id: bus_loaidiemdon_id
		})
		if (res.is_success) {
			yield put(busDangKyXeActions.loadBusDiemDonTraSuccess(res.data || []))
			return;
		}
	} else {
		res = yield call([busDiemDonTraApi, busDiemDonTraApi.SelectByCoSo], dm_coso_id)
		if (res.is_success) {
			const datas: BusDiemDonTraItemResponse[] = res.data || [];
			const filtered = bus_loaidiemdon_id > 0
				? datas.filter((x: BusDiemDonTraItemResponse) => x.bus_loaidiemdon_id === bus_loaidiemdon_id)
				: datas;
			yield put(busDangKyXeActions.loadBusDiemDonTraSuccess(filtered))
			return;
		}
	}
	yield put(busDangKyXeActions.loadBusDiemDonTraError(res.message || "Không tải được danh sách điểm đón trả"))
}

function* loadBusTuyenDuongChiTietWorker(action: IBusDangKyXeTuyenDuongChiTietLoadStart): any {
	const res: IBaseResponeModel = yield call([busTuyenDuongApi, busTuyenDuongApi.SelectTuyenDuongChiTiet], action.payload)
	if (res.is_success) {
		yield put(busDangKyXeActions.loadBusTuyenDuongChiTietSuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.loadBusTuyenDuongChiTietError(res.message || "Không tải được danh sách tuyến đường chi tiết"))
	}
}

function* saveBusDangKyXeWorker(action: IBusDangKyXeSaveStart): any {
	const is_update = action.payload.id > 0;
	if (!is_update) {
		// adm kiểm tra học sinh đã đăng ký cùng hình thức chưa trước khi thêm mới
		const checkExist: IBaseResponeModel = yield call(
			[busDangKyXeApi, busDangKyXeApi.SelectByIdHocSinh],
			action.payload.ts_hocsinh_id,
			action.payload.nam_hoc
		)
		const exist: BusDangKyXeItemResponse | undefined = checkExist.data;
		if (exist != null && exist.bus_hinhthuc_dangky_ma === action.payload.bus_hinhthuc_dangky_ma) {
			if (action.payload.bus_hinhthuc_dangky_ma == "CHIDI") {
				yield put(busDangKyXeActions.saveBusDangKyXeError("Học sinh đã đăng ký chiều đi, vui lòng kiểm tra lại!"))
				return;
			}
			if (action.payload.bus_hinhthuc_dangky_ma == "CHIVE") {
				yield put(busDangKyXeActions.saveBusDangKyXeError("Học sinh đã đăng ký chiều về, vui lòng kiểm tra lại!"))
				return;
			}
			if (action.payload.bus_hinhthuc_dangky_ma == "CAHAI") {
				yield put(busDangKyXeActions.saveBusDangKyXeError("Học sinh đã đăng ký, vui lòng kiểm tra lại!"))
				return;
			}
		}
	}
	let res: IBaseResponeModel;
	if (is_update) {
		res = yield call([busDangKyXeApi, busDangKyXeApi.Update], action.payload);
	} else {
		res = yield call([busDangKyXeApi, busDangKyXeApi.Insert], action.payload);
	}
	if (res.is_success) {
		yield put(busDangKyXeActions.saveBusDangKyXeSuccess(is_update))
	} else {
		yield put(busDangKyXeActions.saveBusDangKyXeError(res.message || "Không lưu được đăng ký bus"))
	}
}

function* deleteBusDangKyXeWorker(action: IBusDangKyXeDeleteStart): any {
	const res: IBaseResponeModel = yield call([busDangKyXeApi, busDangKyXeApi.Delete], action.payload)
	if (res.is_success) {
		yield put(busDangKyXeActions.deleteBusDangKyXeSuccess())
	} else {
		yield put(busDangKyXeActions.deleteBusDangKyXeError(res.message || "Không xoá được đăng ký bus"))
	}
}

function* validateImportBusDangKyXeWorker(action: IBusDangKyXeValidateImportStart): any {
	const res: IBaseResponeModel = yield call([busDangKyXeApi, busDangKyXeApi.ValidateImport], action.payload)
	if (res.is_success) {
		yield put(busDangKyXeActions.validateImportBusDangKyXeSuccess(res.data || []))
	} else {
		yield put(busDangKyXeActions.validateImportBusDangKyXeError(res.message || "Có lỗi"))
	}
}

function* importBusDangKyXeWorker(action: IBusDangKyXeImportStart): any {
	const res: IBaseResponeModel = yield call([busDangKyXeApi, busDangKyXeApi.Import], action.payload)
	if (res.is_success) {
		yield put(busDangKyXeActions.importBusDangKyXeSuccess())
	} else {
		yield put(busDangKyXeActions.importBusDangKyXeError(res.message || "Có lỗi"))
	}
}
